import React from "react"
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";


interface Props {
    component?: React.ElementType
    id?: string
    width?: string
    background?: string
    children?: JSX.Element | JSX.Element[];
    border?: boolean
    marginTop?: number
    marginBottom?: number
    boxShadow?: string
    withMobilePadding?: boolean
    sx?: any
    gridContainerMaxWidth?: string
    dataCypress?: string
    enableSmGrid?: boolean
    alignLeft?: boolean
}

function CCOContainer(props: Props) {

    const cols = props.width === "full" ? 12 :
        (props.width === "large" ? 10 : (props.width === "small" ? 6 : 8))
    const spacecols = props.width === "full" ? 0 :
        (props.width === "large" ? 1 : (props.width === "small" ? 3 : 2))

    const leftOffset = props.alignLeft ? 0 : spacecols;
    const rightOffset = props.alignLeft ? (12 - cols) : spacecols;


    return (
        <Container component={props.component ?? "div"} data-cypress={props.dataCypress} id={props.id} sx={{
            backgroundColor: props.background === 'grey'
                ? 'var(--background-grey)'
                : props.background ? props.background : '',
            width: "100%",
            borderBottom: props.border ? '1px solid #e0e0e0' : 'none',
            borderTop: props.border ? '1px solid #e0e0e0' : 'none',
            boxShadow: props.boxShadow ? props.boxShadow : '',
            mx: 0,
            marginBottom: props.marginBottom ? props.marginBottom : 0,
            marginTop: props.marginTop ? props.marginTop : 0,
            padding: props.withMobilePadding ? {
                xs: '0 16px', sm: '0 24px', md: 'auto'
            } : '0 !important',
            ...props.sx,
        }} maxWidth={false}>
            <Grid
                container
                sx={{
                    width: '100%!important',
                    maxWidth: props.gridContainerMaxWidth || 'xl',
                    m: 'auto'
                }}>
                <Grid size={{xs: 12, sm: props.enableSmGrid ? leftOffset : undefined, md: leftOffset}}></Grid>
                <Grid size={{xs: 12, sm: props.enableSmGrid ? cols : 12, md: cols}}
                      sx={{
                          // styles for correctly displaying RichText elements
                          '> div > ul, > div > ol': {marginBottom: 6},
                          '> div > blockquote + p.small-text, > div > blockquote + p.copy-quote, > div > blockquote + div.small-text, > div > blockquote + div.copy-quote, > div > blockquote > div > span > div.copy-quote, > div > blockquote > div > span > div.small-text':
                              {
                                  textAlign: 'center',
                                  color: 'text.primary'
                              },

                      }}>
                    {props.children}
                </Grid>
                <Grid size={{xs: 12, sm: props.enableSmGrid ? rightOffset : undefined, md: rightOffset}}></Grid>
            </Grid>
        </Container>
    );
}


export default CCOContainer